import React, { useState } from "react";
import { getEnabledAuthProviders } from "./auth/providers";

const formatSignInError = (error) => {
    const message = String(error?.message || error || "");
    if (message) {
        return message;
    }
    return "Sign-in failed. Try again, or try another provider.";
};

const Login = ({ onSuccess }) => {
    const [loadingProviderId, setLoadingProviderId] = useState(null);
    const [statusMessage, setStatusMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const providers = getEnabledAuthProviders();

    const handleLogin = async (provider) => {
        try {
            setErrorMessage("");
            setStatusMessage("Starting…");
            setLoadingProviderId(provider.id);

            const user = await provider.signIn({
                onStatus: (stage) => setStatusMessage(String(stage || "")),
            });

            if (user && onSuccess) {
                onSuccess(user);
            } else if (!user) {
                setErrorMessage(
                    "Sign-in did not finish. Try again, or use another provider."
                );
            }
        } catch (error) {
            console.error(`Error signing in with ${provider.id}`, error);
            setErrorMessage(formatSignInError(error));
        } finally {
            setLoadingProviderId(null);
            setStatusMessage("");
        }
    };

    if (!providers.length) {
        return (
            <div className="homeHint">
                Sign-in is temporarily unavailable.
            </div>
        );
    }

    return (
        <div className="homeAuthButtons">
            {providers.map((provider) => {
                const loading = loadingProviderId === provider.id;

                return (
                    <button
                        key={provider.id}
                        className={
                            provider.buttonClassName || "homePrimaryButton"
                        }
                        onClick={() => handleLogin(provider)}
                        disabled={Boolean(loadingProviderId)}
                    >
                        {loading ? provider.loadingLabel : provider.label}
                    </button>
                );
            })}
            {statusMessage && loadingProviderId ? (
                <div className="homeHint" role="status">
                    {statusMessage}
                </div>
            ) : null}
            {errorMessage ? (
                <div className="homeHint" role="status">
                    {errorMessage}
                </div>
            ) : null}
        </div>
    );
};

export default Login;
